import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Import/Export/Backup';

export const BulkRoutes = [
  {
    path: '/bulk',
    name: 'Import / Export',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/Home.vue'),
  },
  {
    path: '/bulk/importfiles',
    name: 'Import Files',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/ImportFiles.vue'),
    children: [
      {
        path: 'beta',
        name: 'Import Files (Beta)',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/bulk/ImportFilesBeta.vue'),
      },
    ],
  },
  {
    path: '/bulk/exportfiles',
    name: 'Export Files',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/ExportFiles.vue'),
    children: [
      {
        path: 'orig',
        name: 'Export Files (original)',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/bulk/ExportFilesOriginal.vue'),
      },
      {
        path: 'beta',
        name: 'Export Files (beta)',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/bulk/ExportFilesBeta.vue'),
      },
    ],
  },
  {
    path: '/bulk/profileconfig',
    name: 'Profile Config',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/ProfileConfig.vue'),
    children: [
      {
        path: 'transformmapper',
        name: 'Transform Mapper (beta)',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/config/TransformMappers.vue'),
      },
    ],
  },
  {
    path: '/bulk/backuprestoredb',
    name: 'Database Backups',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/BackupRestoreDb.vue'),
  },
  {
    path: '/bulk/datasync',
    name: 'Data Sync to Public',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../components/bulk/DataSyncToPublic.vue'),
  },
  {
    path: '/bulk/additionalscripts',
    name: 'Additional Scripts',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/AdditionalScripts.vue'),
  },
  {
    // This is deprecated version.
    path: '/reports/fileprocessingdetails/:type',
    name: 'File Processing Details',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/FileProcessingDetails.vue'),
  },
  {
    // This is a reusable component, please prefer this for viewing file processing data.
    path: '/bulk/fileprocessingdetails/:type',
    name: 'View File Processing Details',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/bulk/ImportFileProcessedDetails.vue'),
  },
];

BulkRoutes.forEach((element, index) => {
  BulkRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.BankProfileAdmins, ...authRoles.ImportExportAdmins,
      ...authRoles.AuditUsers], next);
  };
});

export default BulkRoutes;
